import { PmDashboardPage } from '@/features/dashboard/pages/PmDashboardPage';

/** Isti prikaz za sve role (ORGANISATION_ADMIN i USER) — backend pm-summary endpoint već dopušta oboje. */
export const DashboardPage = () => <PmDashboardPage />;
